import request from '@/utils/request'

// 查询用户问题反馈列表
export function listUserNote(query) {
    return request({
        url: '/biz/userNote/list',
        method: 'get',
        params: query
    })
}

// 查询用户问题反馈详细
export function getUserNote(id) {
    return request({
        url: '/biz/userNote/' + id,
        method: 'get'
    })
}

// 新增用户问题反馈
export function addUserNote(data) {
    return request({
        url: '/biz/userNote',
        method: 'post',
        data: data
    })
}

// 修改用户问题反馈
export function updateUserNote(data) {
    return request({
        url: '/biz/userNote/update',
        method: 'post',
        data: data
    })
}

// 删除用户问题反馈
export function delUserNote(id) {
    return request({
        url: '/biz/userNote/delete/' + id,
        method: 'post'
    })
}
